export function uniqPrimativeMerge<T>(current: T[] | undefined, newArray?: T | T[]): T[] {
  const primary = current ? current : [];
  const secondary = newArray ? newArray : [];

  const idSet = new Set([...primary, ...secondary]);

  return Array.from(idSet);
}

export function uniqObjectMerge<T>(current: T[], newValues: T[], idFunc: (value: T) => number | string): T[] {
  const dupesRemovedFromOriginal = current.filter(x => {
    const idValue = idFunc(x);
    return !newValues.map(idFunc).includes(idValue);
  });

  return [...dupesRemovedFromOriginal, ...newValues];
}
